import { lazy } from "react";

import { importRemote } from "@module-federation/utilities";
import { MicroFrontendLoader } from "@moodys/mdc-frontend.helpers.micro-frontend-loader";
import { getMFEBasePath } from "@moodys/mdc-shared-runtime";

import { useHeaderContext } from "components/Header/context";

const TypeaheadRemote = lazy(() =>
  importRemote({
    url: getMFEBasePath({
      path: "mfe/web-search",
      staticStructure: true,
    }),
    scope: "MdcWebSearch",
    module: "Search",
    bustRemoteEntryCache: false,
  })
);

const TypeaheadRemoteInLegacy = lazy(() =>
  importRemote({
    url: getMFEBasePath({
      path: "mfe/web-search/external-react",
      staticStructure: true,
    }),
    scope: "MdcWebSearch",
    module: "Search",
    bustRemoteEntryCache: false,
  })
);

export const TypeaheadSearch = () => {
  const { isLegacy } = useHeaderContext();

  return (
    <MicroFrontendLoader renderOnIntersect={false}>
      {isLegacy ? <TypeaheadRemoteInLegacy /> : <TypeaheadRemote />}
    </MicroFrontendLoader>
  );
};
